import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import ImageBackground from '../common/imageBackground';
import ImageText from '../common/imageText';
import ImageButtonList from '../common/imageButtonList';
import NavigationBar from '../common/navigationBar';

class Service6541 extends Component {
  /**************
   * Properties *
   **************/
  pharmacyPopup = {
    id: 'text',
    src: require('./images/Pharmacy_elements.png')
  };
  thankYouPopup = {
    id: 'text',
    src: require('./images/Pharmacy_ThankYou_elements.png')
  };
  buttonList = {
    top: 345,
    left: 280
  };
  buttons = [
    {
      id: 'no',
      to: '/main_menu',
      highlight: require('./images/popup_No_HL.png'),
      unhighlight: require('./images/popup_No_UH.png'),
      alt: 'No, thank you'
    },
    {
      id: 'yes',
      to: '/pharmacy/thank_you',
      highlight: require('./images/popup_Yes_HL.png'),
      unhighlight: require('./images/popup_Yes_UH.png'),
      alt: 'Yes, I want my prescriptions filled here'
    }
  ];
  navigationBar = {
    mainMenu: false,
    back: false,
    backRoute: null
  };
  thankYouNavigationBar = {
    mainMenu: false,
    back: false,
    backRoute: '/main_menu'
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="service-6541">
        <Switch>
          <Route
            path="/pharmacy/thank_you"
            render={routeProps => (
              <PharmacyThankYou {...routeProps} text={this.thankYouPopup} navigationBar={this.thankYouNavigationBar} />
            )}
          />
          <Route
            path="/pharmacy"
            render={routeProps => (
              <PharmacyOptions
                {...routeProps}
                text={this.pharmacyPopup}
                buttonList={this.buttonList}
                buttons={this.buttons}
                navigationBar={this.navigationBar}
              />
            )}
          />
        </Switch>
      </div>
    );
  }
}

class PharmacyOptions extends Component {
  render() {
    return (
      <div>
        <ImageBackground id="background" />
        <ImageText {...this.props.text} />
        <ImageButtonList {...this.props.buttonList} imageButtons={this.props.buttons} />
        <NavigationBar {...this.props.navigationBar} />
      </div>
    );
  }
}

class PharmacyThankYou extends Component {
  handleOnClick = () => {
    this.props.history.push({
      pathname: '/main_menu'
    });
  };

  render() {
    return (
      <div onClick={this.handleOnClick}>
        <ImageBackground id="background" />
        <ImageText {...this.props.text} />
        <NavigationBar {...this.props.navigationBar} />
      </div>
    );
  }
}

export default withRouter(Service6541);
